import { ErrorMessage, Field, FieldAttributes } from "formik";
import React from "react";

interface FieldProps extends FieldAttributes<any> {}

const CustomField: React.FC<FieldProps> = ({
  type,
  name,
  errors,
  touched,
  values,
  handleChange,
  ...rest
}) => {
  return (
    <div>
      {type === "checkbox" ? (
        <div className="form-check">
          <Field
            name={name}
            type="checkbox"
            className={`form-check-input ${
              errors[name] && touched[name] ? "is-invalid" : ""
            }`}
            checked={values[name]}
            onChange={handleChange}
            {...rest}
          />
          {/* <label htmlFor={name} className="form-check-label">
            {name}
          </label> */}
          <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div>
      ) : (
        <div>
          <Field
            name={name}
            type={type}
            className={`form-control ${
              errors[name] && touched[name] ? "is-invalid" : ""
            }`}
            value={values[name]}
            onChange={handleChange}
            {...rest}
          />
          <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div>
      )}
    </div>
  );
};

export default CustomField;
